/**
 * Bootstrap relacji live — modularny JS bez jQuery/Owl (krok 5.3).
 * Krok 6.3 — inteligentny polling (pauza / stop / interwały).
 */

import { onReady, qs } from '../modules/dom.js';
import { initSmoothAnchorScroll } from '../modules/smooth-scroll.js';
import { initNavToggler } from '../modules/nav-toggler.js';
import { initHeaderSearchToggle } from '../modules/header-search-toggle.js';
import { initMatchCarousel, shrinkLongMatchTitles } from '../modules/match-carousel.js';
import {
    initMatchListFilters,
    matchListPollUrl,
    shrinkLongMatchListTitles,
} from '../modules/match-list-filters.js';
import { getMatchSlugFromPath } from '../modules/match-slug.js';
import { pollFragment } from '../modules/polling.js';
import { scrollCourseToBottom, hideDuplicateHeats } from '../modules/course-ui.js';
import { initGeneralScoring, refreshSquadFromCourse } from '../modules/scoring-general.js';
import {
    INTERVAL_LIVE_MS,
    INTERVAL_PLANNED_MS,
    isTerminalMatchStatus,
    readInitialMatchStatus,
} from '../modules/match-poll-status.js';

function refreshMatchListUi(container) {
    if (!container) {
        return;
    }
    if (qs('[data-match-carousel]', container)) {
        initMatchCarousel(container);
        shrinkLongMatchTitles(container);
        return;
    }
    if (qs('[data-match-list-filters]', container)) {
        const filters = qs('[data-match-list-filters]', container);
        if (filters) {
            delete filters.dataset.bound;
        }
        const pagination = qs('[data-match-list-pagination]', container);
        if (pagination) {
            delete pagination.dataset.bound;
        }
        initMatchListFilters({
            onChange: () => {
                container.dispatchEvent(new CustomEvent('matchlist:filter-change'));
            },
        });
        shrinkLongMatchListTitles(container);
    }
}

onReady(() => {
    initSmoothAnchorScroll();
    initNavToggler();
    initHeaderSearchToggle();
    scrollCourseToBottom(true);

    const matchSlug = getMatchSlugFromPath();
    const hasCarousel = !!qs('[data-match-carousel]');
    const hasListFilters = !!qs('[data-match-list-filters]');

    if (hasCarousel) {
        initMatchCarousel();
        shrinkLongMatchTitles();
    }

    if (hasListFilters) {
        initMatchListFilters({
            onChange: () => {
                const container = qs('.matchlist-container, .match-carousel__container');
                if (container) {
                    container.dispatchEvent(new CustomEvent('matchlist:filter-change'));
                }
            },
        });
        shrinkLongMatchListTitles();
    }

    initGeneralScoring();

    window.setTimeout(hideDuplicateHeats, 1000);

    const initialStatus = readInitialMatchStatus();
    const livePollOptions = {
        intervalLiveMs: INTERVAL_LIVE_MS,
        intervalPlannedMs: INTERVAL_PLANNED_MS,
        pauseWhenHidden: true,
        stopWhenTerminal: true,
    };

    if (!isTerminalMatchStatus(initialStatus)) {
        pollFragment('.match-course', () => 'course.php?match=' + getMatchSlugFromPath(), {
            ...livePollOptions,
            highlightCourse: true,
            onDone: () => {
                refreshSquadFromCourse();
                window.setTimeout(hideDuplicateHeats, 1000);
            },
        });

        pollFragment('.match-comments-ajax', () => 'comments.php?match=' + getMatchSlugFromPath(), {
            ...livePollOptions,
        });
    }

    const matchlistUrl = () => {
        if (qs('[data-match-list-filters]')) {
            return matchListPollUrl();
        }
        return matchSlug ? 'matchlist.php?match=' + encodeURIComponent(matchSlug) : 'matchlist.php';
    };

    pollFragment('.matchlist-container, .match-carousel__container', matchlistUrl, {
        intervalMs: INTERVAL_LIVE_MS,
        pauseWhenHidden: true,
        onDone: (container) => refreshMatchListUi(container),
    });

    // Natychmiastowe odświeżenie po zmianie filtrów.
    const container = qs('.matchlist-container, .match-carousel__container');
    if (container && hasListFilters) {
        container.addEventListener('matchlist:filter-change', () => {
            fetch(matchlistUrl(), { credentials: 'same-origin' })
                .then((r) => (r.ok ? r.text() : Promise.reject()))
                .then((html) => {
                    container.innerHTML = html;
                    refreshMatchListUi(container);
                })
                .catch(() => {});
        });
    }
});
